import React from 'react';

interface DownloadAttachmentProps {
    fill?: string;
    width?: number;
    height?: number;
}

export const DownloadAttachment = ({
    fill = 'black',
    height = 14,
    width = 16,
}: DownloadAttachmentProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={`${width}`}
            height={`${height}`}
            viewBox="0 0 16 14"
            fill="none"
        >
            <path
                d="M0.5 8.89999C0.632608 8.89999 0.759785 8.95267 0.853553 9.04644C0.947322 9.14021 1 9.26739 1 9.39999V11.9C1 12.1652 1.10536 12.4196 1.29289 12.6071C1.48043 12.7946 1.73478 12.9 2 12.9H14C14.2652 12.9 14.5196 12.7946 14.7071 12.6071C14.8946 12.4196 15 12.1652 15 11.9V9.39999C15 9.26739 15.0527 9.14021 15.1464 9.04644C15.2402 8.95267 15.3674 8.89999 15.5 8.89999C15.6326 8.89999 15.7598 8.95267 15.8536 9.04644C15.9473 9.14021 16 9.26739 16 9.39999V11.9C16 12.4304 15.7893 12.9391 15.4142 13.3142C15.0391 13.6893 14.5304 13.9 14 13.9H2C1.46957 13.9 0.960859 13.6893 0.585786 13.3142C0.210714 12.9391 0 12.4304 0 11.9V9.39999C0 9.26739 0.0526784 9.14021 0.146447 9.04644C0.240215 8.95267 0.367392 8.89999 0.5 8.89999Z"
                fill={fill}
            />
            <path
                d="M7.64602 10.854C7.69247 10.9006 7.74764 10.9375 7.80839 10.9627C7.86913 10.9879 7.93425 11.0009 8.00002 11.0009C8.06579 11.0009 8.13091 10.9879 8.19165 10.9627C8.2524 10.9375 8.30758 10.9006 8.35402 10.854L11.354 7.854C11.4479 7.76011 11.5007 7.63278 11.5007 7.5C11.5007 7.36722 11.4479 7.23989 11.354 7.146C11.2601 7.05211 11.1328 6.99937 11 6.99937C10.8672 6.99937 10.7399 7.05211 10.646 7.146L8.50002 9.293V0.5C8.50002 0.367392 8.44734 0.240215 8.35358 0.146447C8.25981 0.0526784 8.13263 0 8.00002 0C7.86741 0 7.74024 0.0526784 7.64647 0.146447C7.5527 0.240215 7.50002 0.367392 7.50002 0.5V9.293L5.35402 7.146C5.26013 7.05211 5.1328 6.99937 5.00002 6.99937C4.86725 6.99937 4.73991 7.05211 4.64602 7.146C4.55213 7.23989 4.49939 7.36722 4.49939 7.5C4.49939 7.63278 4.55213 7.76011 4.64602 7.854L7.64602 10.854Z"
                fill={fill}
            />
        </svg>
    );
};
